module.exports = __webpack_public_path__ + "assets/images/boundaries/comparison/2015/desktop.svg?v=46a7edc2";